import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { requestIcon } from '../constants';

const RequestTransferButton = ({ className, onClick, request }) => {
  const { icon, message, color } = requestIcon(request, true);
  return (
    <Button
      size="tiny"
      labelPosition="left"
      icon
      basic
      className={`aridhia-request-transfer-button ${className} ${color}`}
      onClick={onClick}
    >
      <Icon name={icon} />
      <FormattedMessage id={message} />
    </Button>
  );
};

export default RequestTransferButton;
